module.exports = __webpack_public_path__ + "media/images/btn_add_email-b252890429056f4491ecbb248eb0b05c.gif";